import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiFire, HiX } from './Icons';
import './ActivityTicker.css';

interface ActivityItem {
  id: number;
  dealName: string;
  dealSlug: string;
  benefit: string;
  location: string;
  timeAgo: string;
}

const ACTIVITIES: ActivityItem[] = [
  {
    id: 1,
    dealName: 'American Express Platinum',
    dealSlug: 'american_express_platinum',
    benefit: '85.000 Punkte Willkommensbonus',
    location: 'Frankfurt am Main',
    timeAgo: 'vor 3 Minuten'
  },
  {
    id: 2,
    dealName: 'Uber Eats',
    dealSlug: 'uber_eats',
    benefit: '15€ Essensgutschein',
    location: 'Berlin',
    timeAgo: 'vor 7 Minuten'
  },
  {
    id: 3,
    dealName: 'N26',
    dealSlug: 'n26',
    benefit: 'Kostenloses Girokonto + Prämie',
    location: 'München',
    timeAgo: 'vor 12 Minuten'
  },
  {
    id: 4,
    dealName: 'HelloFresh',
    dealSlug: 'hellofresh',
    benefit: '1 Woche Gratis-Kochboxen',
    location: 'Hamburg',
    timeAgo: 'vor 18 Minuten'
  },
  {
    id: 5,
    dealName: 'Grover',
    dealSlug: 'grover',
    benefit: '20€ Tech-Mietguthaben',
    location: 'Köln',
    timeAgo: 'vor 24 Minuten'
  }
];

export const ActivityTicker: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isDismissed, setIsDismissed] = useState<boolean>(false);

  useEffect(() => {
    const isMuted = sessionStorage.getItem('activity_ticker_muted');
    if (isMuted === 'true') {
      setIsDismissed(true);
      return;
    }

    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 4000);

    // Rotation interval
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % ACTIVITIES.length);
        setIsVisible(true);
      }, 800);
    }, 18000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem('activity_ticker_muted', 'true');
  };

  if (isDismissed) return null;

  const currentActivity = ACTIVITIES[currentIndex];

  return (
    <div className={`activity-ticker-container ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="activity-ticker-card">
        <div className="ticker-icon-box">
          <HiFire className="ticker-fire-icon" />
        </div>
        <div className="ticker-content">
          <div className="ticker-meta">
            <span className="ticker-live-dot"></span>
            <span className="ticker-time">{currentActivity.timeAgo}</span>
            <span className="ticker-bullet">•</span>
            <span className="ticker-loc">{currentActivity.location}</span>
          </div>
          <p className="ticker-text">
            Jemand hat sich <strong>{currentActivity.benefit}</strong> bei{' '}
            <Link to={`/${currentActivity.dealSlug}`} className="ticker-deal-link">
              {currentActivity.dealName}
            </Link>{' '}
            gesichert!
          </p>
        </div>
        <button
          className="ticker-close-btn"
          onClick={handleDismiss}
          aria-label="Benachrichtigung schließen"
        >
          <HiX />
        </button>
      </div>
    </div>
  );
};

export default ActivityTicker;
